// Persisted Matrix session storage. Deliberately free of any `matrix-js-sdk`
// import: `authService` clears the chat session on sign-out, and pulling in
// `client.ts` from there would drag the whole SDK into the auth bundle.

const SESSION_KEY = 'sevv-chat:session'

export interface Session {
  baseUrl: string
  accessToken: string
  userId: string
  deviceId: string
}

export function loadSession(): Session | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (!raw) return null
    const s = JSON.parse(raw) as Session
    if (s.accessToken && s.userId && s.baseUrl) return s
    return null
  } catch {
    return null
  }
}

export function saveSession(s: Session): void {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(s))
  } catch {
    /* storage can throw (Safari private mode, quota) — the session still works in-memory */
  }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(SESSION_KEY)
  } catch {
    /* ignore */
  }
}
